export function smallNumberFilterSeconds(currentNumber: number): boolean {
    return currentNumber < 60; // Use to filter out rows with time values less than 5 seconds
}

export function smallNumberFilterPercent(currentNumber:number): boolean {
    return currentNumber <2 // Use this to filter out insignificant percentage values
}

export function smallNumberFilterString(currentNumber:string): boolean {
    const match = currentNumber.match(/(\d+)\s*hrs/);
    const hours = match ? Number(match[1]) : null;
    let processedNumber = hours 
    console.log(processedNumber)
    if (processedNumber === null) {
        return false
    }
    else {
        return processedNumber < 1
    }
}
